<template>
  <base-input v-on="$listeners"
              input-type="text"
              :value="value"
              :label="label"
              :error-message="errorMessage"
              :max-length="maxLength"
              :autofocus="autofocus"
              :autocapitalize="autocapitalize"
              :input-pattern="inputPattern"
              :readonly="readonly">
    <template v-slot:append>
      <slot name="append"/>
    </template>
  </base-input>
</template>

<script>
import BaseInput from './BaseInput.vue';

export default {
  name: 'DefaultTextInput',
  components: { BaseInput },
  props: {
    value: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    errorMessage: {
      type: String,
      default: '',
    },
    maxLength: {
      type: Number,
      default: 1000,
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    inputPattern: {
      type: String,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    autocapitalize: {
      type: String,
      default: 'none',
    },
  },

};
</script>
